export const PAGESAccess = {
  STATISTICS: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  ORDER: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  ORDERS: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  ClIENTS: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  DOCTORS: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  EMPOLOYEES: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  ROLES: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  FILIALS: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  TYPES_PAYMENT: {
    add: false,
    delete: false,
    edit: false,
    read: false
  },
  SERVICE: {
    add: false,
    delete: false,
    edit: false,
    read: false
  }
};
export const PAGESAdminAccess = {
  STATISTICS: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  ORDER: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  ORDERS: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  ClIENTS: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  DOCTORS: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  EMPOLOYEES: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  ROLES: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  FILIALS: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  TYPES_PAYMENT: {
    add: true,
    delete: true,
    edit: true,
    read: true
  },
  SERVICE: {
    add: true,
    delete: true,
    edit: true,
    read: true
  }
};
